export { default as stringWidth, eastAsianCharacterInfo } from "./stringWidth";

export * from "./measure";
//# sourceMappingURL=index.js.map
